/**
 * 验真服务 - 二维码/NFC验证
 */
import { api } from './api'

export interface VerifyByCodeParams {
  code: string
  geo?: {
    province?: string
    city?: string
    lat?: number
    lng?: number
  }
}

export interface VerifyByNfcParams {
  code: string
  nfcUid: string
  signature: string
  timestamp: number
  geo?: {
    province?: string
    city?: string
  }
}

export interface VerifyResult {
  isAuthentic: boolean
  riskScore: number
  warnings: string[]
  asset?: {
    id: string
    name: string
    collection: string
    image: string
    metadata?: any
  }
  scanCount: number
  lastScanAt?: string
  firstScanAt: string
}

export interface VerificationHistory {
  id: string
  code: string
  ip: string
  location?: string
  userAgent: string
  isAuthentic: boolean
  riskScore: number
  createdAt: string
}

export interface DestroyReportParams {
  code: string
  reason: string
  evidence?: string
}

export const verifyService = {
  /** 验真码验证 */
  verifyByCode(params: VerifyByCodeParams): Promise<VerifyResult> {
    return api.post('/verify/code', params)
  },

  /** NFC芯片验证 */
  verifyByNfc(params: VerifyByNfcParams): Promise<VerifyResult> {
    return api.post('/verify/nfc', params)
  },

  /** 获取验证记录 */
  getVerificationHistory(code: string): Promise<VerificationHistory[]> {
    return api.get('/verify/history', { code })
  },

  /** 标签销毁上报 */
  destroyReport(params: DestroyReportParams): Promise<{ success: boolean }> {
    return api.post('/verify/destroy-report', params)
  },
}

export default verifyService
